import React, { useState, useEffect } from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";
import { useSelector, useDispatch } from "react-redux";
import { updateDataSearch } from "../../../actions/DanhSachTatToanChoDuyet";
import { formatNumber } from "utils/currencyFormat";

export const TableList = ({ SearchDanhSach, dataDanhSach, phanQuyen }) => {
  const dispatch = useDispatch();
  // const listTatToanChoDuyetFull = useSelector(
  //     (state) => state.listTatToanChoDuyetFull
  // );

  const dataSearch = useSelector((state) => state.dataSearchTatToanChoDuyet);
  useEffect(() => {
    SearchDanhSach();
  }, []);

  const loadTaiSan = () => {
    // getListTatToanChoDuyet(dataSearch);
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }; // set lên đầu page ví dụ khi phân trang

  const handlePageChange = (pageNumber) => {
    dataSearch.pageIndex = pageNumber;
    dispatch(
      updateDataSearch({
        ...dataSearch,
        pageIndex: pageNumber,
      })
    );
    SearchDanhSach();
    loadTaiSan(dataSearch);
    //setpageNumber(pageNumber);
  };
  const TotalQuantity = dataDanhSach.TongBanGhi;
  return (
    <>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new  css-table-ds">
            <div className="loading-page1">
              <div
                className={
                  "loader loader-default " +
                  (dataDanhSach.getListTatToanChoDuyetLoading
                    ? "is-active"
                    : "")
                }
              ></div>
            </div>
            <div className="table-mobile sticky-table-bh2 table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                    <p className="text-center">
                      STT
                      <br />{" "}
                      <span className="color-do-bold">
                        [ {dataDanhSach.TongBanGhi} ]
                      </span>
                    </p>
                  </div>

                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="text-center">Mã hợp đồng</p>
                  </div>

                  <div className="custom-table-header flex-basis-12 flex-basis-12-sm">
                    <p>Tên khách hàng</p>
                  </div>
                  <div className="custom-table-header flex-basis-8 flex-basis-8-sm">
                    <p className="text-center">Thời gian</p>
                  </div>

                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="text-right">
                      Tiền tất toán
                      <br />
                      <span>{formatNumber(dataDanhSach.TongSoTien)}</span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-7 flex-basis-7-sm">
                    <p className="text-right">
                      Phí khác
                      <br />
                      <span className="color-do-bold">
                        {formatNumber(dataDanhSach.TongPhiKhac)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-7 flex-basis-7-sm">
                    <p className="text-right">
                      Phí kho
                      <br />
                      <span className="color-xanh-bold">
                        {formatNumber(dataDanhSach.TongPhiKho)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-7 flex-basis-7-sm">
                    <p className="text-right">
                      Phí hàng kỳ
                      <br />
                      <span className="color-cam-bold">
                        {formatNumber(dataDanhSach.TongPhiHangKy)}
                      </span>
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-12-sm">
                    <p className="text-center">Ghi chú</p>
                  </div>
                  <div className="custom-table-header flex-basis-12 flex-basis-12-sm">
                    <p className="text-center">Trạng thái</p>
                  </div>

                  <div className="custom-table-header flex-basis-11 flex-basis-11-sm action-cell">
                    <p className="tab-header">Chức năng</p>
                  </div>
                </div>

                <div className="custom-table-body">
                  <ContentTable
                    listTatToanChoDuyetFull={dataDanhSach.List}
                    phanQuyen={phanQuyen}
                    SearchDanhSach={SearchDanhSach}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-3 card-v2"
        style={{
          marginLeft: "15px",
          marginRight: "15px",
        }}
      >
        <div className="card-body card-body-v2">
          <div className="row">
            <div className="col-sm-12 col-md-6">
              <span className="color7">
                {TotalQuantity === 0 ? (
                  "Hiển thị 0 - 0 / Tổng số 0"
                ) : (
                  <>
                    Hiển thị{" "}
                    {(dataSearch.pageIndex - 1) * dataSearch.pageSize + 1} -{" "}
                    {Math.min(
                      dataSearch.pageIndex * dataSearch.pageSize,
                      TotalQuantity
                    )}{" "}
                    / Tổng số {TotalQuantity}
                  </>
                )}
              </span>
            </div>
            <div className="col-sm-12 col-md-6">
              <div
                className={
                  "paniation-new paniation-new1 d-flex justify-content-center " +
                  (TotalQuantity === 0 ? "hidden" : "")
                }
                style={{ float: "right" }}
              >
                <nav aria-label="Page navigation">
                  <Pagination
                    activePage={dataSearch.pageIndex}
                    itemsCountPerPage={dataSearch.pageSize}
                    totalItemsCount={TotalQuantity}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item border-none"
                    linkClass="page-link border-none"
                    activeClass="active"
                  />
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
